<template>
  <radio-selection
      :options="urgencyOptions"
      :value="value"
      @change="$emit('input', $event)"/>
</template>

<script>
import { URGENCIES } from '@/constants/urgencies';
import RadioSelection from '../../components/RadioSelection';

export default {
  name: 'urgency',
  components: {
    RadioSelection,
  },
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    urgencyOptions () {
      return Object.keys(URGENCIES).filter(key => key < 7 && key > 4).map(key => URGENCIES[key]);
    },
  },
};
</script>
